import { FC } from 'react';
import classNames from 'classnames';

type BuyersPremiumItemProps = {
  name: string;
  buyersPremiumPercentage: string;
  buyersPremiumPromotionPercentage?: string;
  isHighlighted?: boolean;
  isDark?: boolean;
};

export const BuyersPremiumItem: FC<BuyersPremiumItemProps> = ({
  name,
  buyersPremiumPercentage,
  isDark,
  buyersPremiumPromotionPercentage,
  isHighlighted = false
}) => {
  const hasPromotion = typeof buyersPremiumPromotionPercentage === 'string';

  return (
    <div
      className={classNames('mb-2 border px-4 d-flex align-items-center justify-content-between border-radius-16', {
        'border-success': isHighlighted && !isDark,
        'border-turquoise': isHighlighted && isDark,
        'border-light20': !isHighlighted && isDark
      })}
      style={{
        height: '72px'
      }}
    >
      <span className={classNames('letter-spacing-007', { 'text-light': isDark })}>{name}</span>
      <span className='text-secondary'>
        {hasPromotion && (
          <span className={isDark ? 'text-turquoise' : 'text-success'}>{buyersPremiumPromotionPercentage} </span>
        )}
        <span className={classNames({ 'text-decoration-line-through': hasPromotion })}>{buyersPremiumPercentage}</span>
      </span>
    </div>
  );
};
